const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded', () => {

    const el = document.querySelector('.js-nav'),
          menu = document.querySelector('.js-menu'),
          hamburger = document.querySelector('.js-hamburger');

    const init = function() {

        let ww = 0;

        const checkWindowWidth = () => {
            ww = window.innerWidth;
            ww > 1200 ? hideMenu() : false;
        }
        
        window.hideMenu = function() {
            enableBodyScroll(document.querySelector('.js-nav'));
            document.querySelector('.js-nav').classList.remove('is-visible');
            document.querySelector('.js-hamburger').classList.remove('is-active');
            document.documentElement.classList.remove('menu-opened');
        };

        const showMenu = function(e) {
            if (e.currentTarget.classList.contains('is-active')) {
                hideMenu();            
            } else {
                disableBodyScroll(el);
                document.documentElement.classList.add('menu-opened');
                el.classList.add('is-block');
                setTimeout(function() {
                    el.classList.add('is-visible');
                    hamburger.classList.add('is-active');                    
                }, 10);
            }
        };

        window.addEventListener('resize', checkWindowWidth);

        checkWindowWidth();

        hamburger.addEventListener('click', showMenu);

        // Hide menu on ESC
        document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                hideMenu();
            }
        });
    };

    el ? init() : false;

}, false);